import React, { Fragment } from 'react';
import { Dialog } from './../../common/dialog';
import Dropzone from 'react-dropzone';

const UploadModal = React.memo((props) => {
    const hideHandler = () => {
        props.hideUploadModal();
    };

    const uploadHandler = () => {
        // if(confirmValue === '') {
        //     setErrorMessage('The Form # is empty');
        //     return;
        // }

        props.uploadExcel();
    };

    const onDrop = (acceptedFiles) => {
        props.setUploadFile(acceptedFiles[0]);
    };

    let label = 'Upload';
    if (props.isUploading) {
        label = <i className="fas fa-circle-notch fa-spin" />;
    }

    let actions = [
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Cancel</button>,
        <button key="upload-button" className="btn btn-light btn-sm action-button" onClick={uploadHandler} disabled={props.isUploading}>{label}</button>
    ];
    return (
        <Dialog
            name="upload-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 800 }}
            bodyStyle={{ overflow: 'initial' }}
            className="admin-apparel-items-upload-dialog"
        >
            <div className="admin-apparel-items-upload-modal-container">
                <h1>Upload Excel</h1>
                <p className="notice">
                    <span>Warning:</span> Uploading an Excel file will add or replace the Apparel Items that are present in the spreadsheet. Make sure you
                    don't have duplicated items in your file or duplicated items will appear in the database. The system will use a combination of the SKU, 
                    size and logo columns to match the items in the database and update them or add them. The file must be in the Master Template format 
                    that is exported from this section, with the same Column names and positions.
                    <br />
                    <br />
                    New Apparel Items will be created inactive (this means they will not visible on the platform yet) and without Images. After the creation 
                    you can go to the items individually to upload their images. The Image files cannot be changed using the spreadsheet.
                </p>
                <Dropzone onDrop={onDrop} accept=".xlsx,.xls">
                    {({ getRootProps, getInputProps }) => (
                        <div className="upload-file-container">
                            <div {...getRootProps()} className="button">
                                <input {...getInputProps()} />
                                Click here to upload a file
                            </div>
                            <div className="file-name">
                                {props.uploadFile != null ? <Fragment><b>Selected File:</b> {props.uploadFile.name}</Fragment> : null}
                            </div>
                        </div>
                    )}
                </Dropzone>
            </div>
        </Dialog >
    );
});

export default UploadModal;
